import { FC } from 'react';

import { TEXTS } from 'application/pages/texts';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Popper from '@zvuk-b2b/react-uikit/ui/Popper';

import styles from './index.module.scss';

interface AcceptanceAdvancedPopperProps {
  isAcceptanceAdvancedPending: boolean;
  hasSberConnection: boolean;
  handleAddPointClick: () => void;
  handleAcceptanceAdvancedSigningClick: () => void;
}

const AcceptanceAdvancedPopper: FC<AcceptanceAdvancedPopperProps> = ({
  isAcceptanceAdvancedPending,
  hasSberConnection,
  handleAddPointClick,
  handleAcceptanceAdvancedSigningClick,
}) => (
  <Popper
    key="popper_create_new_point_modal"
    triggerNode={
      <div>
        <Button
          key="button_create_new_point_modal"
          elementId="button_create_new_point_modal"
          type={ButtonType.SECONDARY}
          isDisabled={isAcceptanceAdvancedPending}
          onClick={handleAddPointClick}>
          {TEXTS.MODAL_BIND_ADD_NEW_POINT_TEXT}
        </Button>
      </div>
    }
    isShow={isAcceptanceAdvancedPending}
    portalNode={document.body}
    containerClassName={styles.popperWrapper}
    popperClassName={styles.popper}>
    <span>{TEXTS.MODAL_BIND_ADD_NEW_POINT_HINT_ACCEPTANCE_ADVANCED}</span>

    {!hasSberConnection ? (
      <p>{TEXTS.MODAL_BIND_NO_SBER_CONNECTION_TEXT}</p>
    ) : (
      <Button
        elementId="button_acceptance_advanced_open"
        className={styles.hintButton}
        type={ButtonType.PLAIN}
        onClick={handleAcceptanceAdvancedSigningClick}>
        {TEXTS.MODAL_BIND_ADD_NEW_POINT_HINT_ACCEPTANCE_ADVANCED_BUTTON}
      </Button>
    )}
  </Popper>
);

export default AcceptanceAdvancedPopper;
